import { languageItem } from '@/language/helpers'
import MembershipModal from '@/modals/MembershipModal.vue'
import { openModal } from '@/modals/helpers/api'

export function openMembershipModal() {
  const t = languageItem('membershipModal')
  openModal({
    name: 'membership-modal',
    title: t.title,
    component: MembershipModal,
  })
}
